import { useState, CSSProperties } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Alert from "@mui/material/Alert";
import { CircularProgress } from "@material-ui/core";
import { Popover, Typography } from "@material-ui/core";
import "../../styling/sidebar.css";
import "../../styling/expensepop.css";
import GetUser from "../../services/get-user";

import {
  useCSVReader,
  lightenDarkenColor,
  formatFileSize,
} from "react-papaparse";
import { toast } from "react-toastify";
import CsvWithAdvanceOptionSale from "./csvWithAdvanceOptionSale";

const GREY = "#CCC";
const GREY_LIGHT = "rgba(255, 255, 255, 0.4)";
const DEFAULT_REMOVE_HOVER_COLOR = "#A01919";
const REMOVE_HOVER_COLOR_LIGHT = lightenDarkenColor(
  DEFAULT_REMOVE_HOVER_COLOR,
  40
);
const GREY_DIM = "#686868";

const styles = {
  zone: {
    alignItems: "center",
    borderWidth: 2,
    borderStyle: "dashed",
    borderColor: GREY,
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    padding: 20,
  } as CSSProperties,
  file: {
    background: "linear-gradient(to bottom, #EEE, #DDD)",
    borderRadius: 20,
    display: "flex",
    height: 120,
    width: 120,
    position: "relative",
    zIndex: 10,
    flexDirection: "column",
    justifyContent: "center",
  } as CSSProperties,
  info: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    paddingLeft: 10,
    paddingRight: 10,
  } as CSSProperties,
  size: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    marginBottom: "0.5em",
    justifyContent: "center",
    display: "flex",
  } as CSSProperties,
  name: {
    backgroundColor: GREY_LIGHT,
    borderRadius: 3,
    fontSize: 12,
    marginBottom: "0.5em",
  } as CSSProperties,
  progressBar: {
    bottom: 14,
    position: "absolute",
    width: "100%",
    paddingLeft: 10,
    paddingRight: 10,
  } as CSSProperties,
  zoneHover: {
    borderColor: GREY_DIM,
  } as CSSProperties,
  default: {
    borderColor: GREY,
  } as CSSProperties,
  remove: {
    height: 23,
    position: "absolute",
    right: 6,
    top: 6,
    width: 23,
  } as CSSProperties,
};
function ReadSaleCsv(props) {
  const { CSVReader } = useCSVReader();
  const [zoneHover, setZoneHover] = useState(false);
  const [removeHoverColor, setRemoveHoverColor] = useState(
    DEFAULT_REMOVE_HOVER_COLOR
  );

  const [csvFileData, setCsvFileData] = useState<any[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [loading, setLoading] = useState(false);
  const openTooltip = Boolean(anchorEl);
  const [advanceDisableButton, setAdvanceDisableButton] = useState(true);
  const [importDisableButton, setImportDisableButton] = useState(true);
  const user = GetUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      // return axios.post('http://localhost:8080/expense/add_csv_expense', {
      return axios
        .post("https://sotira-back-test.herokuapp.com/sale/add_csv_sale", {
          userID: user.userID,
          incomeStream: props.stream + 1,
          sales: csvFileData,
        })
        .then((response) => {
          sessionStorage.setItem("option", "sales");
          toast.success("File Uploaded successfully.", {
            position: "top-right",
            autoClose: 15000,
          });
          setLoading(false);
          props.setOpenSalesCsvModal(false);
          if(props.closeExpenseModal!==undefined){ 
            props.closeSaleModal(false)
          };
          props.setReloadAPI((prevState)=>!prevState)
        });
    } catch (e: any) {
      setLoading(false);
      alert(e.response.data);
    }
  };

  function getCsvFileData(results) {
    const csvFileRecords = results.data; 
    const fileHeaders = csvFileRecords[0].map((head) => String(head).toLowerCase().trim()); 
    if(fileHeaders.length >=2){
      if (
        fileHeaders.indexOf("name") === -1 ||
        fileHeaders.indexOf("customer") === -1 ||
        fileHeaders.indexOf("fee") === -1
      ) {
        setImportDisableButton(true);
        setAdvanceDisableButton(false);
        toast.error("Name or Customer or Fee Header is missing.", {
          position: "top-right",
          autoClose: 15000,
        });
        const filesRows = csvFileRecords.slice(1); 
        if (filesRows.length === 0) {
          setImportDisableButton(true);
          setAdvanceDisableButton(true);
          return ["No good data was found"];
        }
        setCsvFileData(csvFileRecords)
        return ["bad"];

      } else {
        const fileLastRowsLength = csvFileRecords[csvFileRecords.length - 1].length;
        const fileFirstRowsLength = csvFileRecords[0].length;
        const fileRows = fileFirstRowsLength===fileLastRowsLength ? csvFileRecords.slice(1) :csvFileRecords.slice(1,csvFileRecords.length-1);
        const nameIndex = fileHeaders.indexOf("name");
        const customerIndex = fileHeaders.indexOf("customer");
        const feesIndex = fileHeaders.indexOf("fee");
        const amountIndex = fileHeaders.indexOf("amount");
        const dateIndex = fileHeaders.indexOf("date");
  
        var sendCsvData: any[] = [];
  
        for (var i in fileRows) {
          if (
            fileRows[i][nameIndex] != "" &&
            fileRows[i][customerIndex] != "" &&
            fileRows[i][feesIndex] != ""
          ) {
            const typeFee = typeof fileRows[i][feesIndex]
            fileRows[i][feesIndex] = fileRows[i][feesIndex] && 
                          (typeFee === 'string' &&  fileRows[i][feesIndex].startsWith("$"))? fileRows[i][feesIndex].replaceAll(",","").split("$").join("").trim() : Number(fileRows[i][feesIndex]);
            if(isNaN(fileRows[i][feesIndex]) || !fileRows[i][feesIndex]){
              toast.error("Fee should be number");
              break;
            }else{
              Number(fileRows[i][feesIndex])
            }
            const typeAmount = typeof fileRows[i][amountIndex]
            fileRows[i][amountIndex] = fileRows[i][amountIndex] && 
                          (typeAmount === 'string' &&  fileRows[i][amountIndex].startsWith("$"))? fileRows[i][amountIndex].replaceAll(",","").split("$").join("").trim() : Number(fileRows[i][amountIndex]);
            if(isNaN(fileRows[i][amountIndex]) || !fileRows[i][amountIndex]){
              toast.error("amount should be number");
              break;
            }else{
              Number(fileRows[i][amountIndex])
            }
            if (dateIndex != -1) {
              var sendDate = new Date(fileRows[i][dateIndex]);
              var currDate = new Date();
              if (
                isNaN(sendDate.getTime()) ||
                sendDate.getTime() > currDate.getTime()
              ) {
                sendDate = new Date();
              }
  
              fileRows[i][dateIndex] = sendDate;
            }
            sendCsvData.push(fileRows[i]);
          }
        }
        setImportDisableButton(false);
        setAdvanceDisableButton(false);
  
        if (sendCsvData.length === 0) {
          setImportDisableButton(true);
          setAdvanceDisableButton(true);
          return ["No good data was found"]
        }
        sendCsvData.unshift(fileHeaders);
        setCsvFileData(sendCsvData);
        return sendCsvData; 
      } 
    }else{
      setImportDisableButton(true);
      setAdvanceDisableButton(true);
      toast.error("Name or Customer or Fee Header is missing.", {
        position: "top-right",
        autoClose: 15000,
      });
    }   
  }

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {openModal && (
        <CsvWithAdvanceOptionSale
          csvFileRecords={csvFileData.filter((data) => data.length >= 2)}
          stream={props.stream}
          openModal={openModal}
          setOpenModal={(isOpen) => {
            setOpenModal(isOpen)
            if (!isOpen && props.setOpenSalesCsvModal) {
              props.setOpenSalesCsvModal(false);
            }
          }}
          closeSaleModal={props.closeSaleModal}
          setReloadAPI={props.setReloadAPI}
        ></CsvWithAdvanceOptionSale>
      )}
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <div>
            Example of an acceptable csv file:{" "}
            <a
              href="https://uploads-ssl.webflow.com/61dd2460f99ba00b4d9075ec/621c9fb7dd1021308b556765_acceptable-csv.png"
              target="_blank"
            >
              {" "}
              Example{" "}
            </a>
            ('Name', 'Customer' and 'Fee' columns are mandatory)
          </div>
        </Form.Group>
        <Form.Group>
          <CSVReader
            onUploadAccepted={(results: any) => {
              getCsvFileData(results);
              setZoneHover(false);
            }}
            onDragOver={(event: DragEvent) => {
              event.preventDefault();
              setZoneHover(true);
            }}
            onDragLeave={(event: DragEvent) => {
              event.preventDefault();
              setZoneHover(false);
            }}
          >
            {({
              getRootProps,
              acceptedFile,
              ProgressBar,
              getRemoveFileProps,
              Remove,
            }: any) => (
              <>
                <div
                  {...getRootProps()}
                  style={Object.assign(
                    {},
                    styles.zone,
                    zoneHover && styles.zoneHover
                  )}
                >
                  {acceptedFile ? (
                    <>
                      <div style={styles.file}>
                        <div style={styles.info}>
                          <span style={styles.size}>
                            {formatFileSize(acceptedFile.size)}
                          </span>
                          <span style={styles.name}>{acceptedFile.name}</span>
                        </div>
                        <div style={styles.progressBar}>
                          <ProgressBar />
                        </div>
                        <div
                          {...getRemoveFileProps()}
                          style={styles.remove}
                          onMouseOver={(event: Event) => {
                            event.preventDefault();
                            setRemoveHoverColor(REMOVE_HOVER_COLOR_LIGHT);
                          }}
                          onMouseOut={(event: Event) => {
                            event.preventDefault();
                            setRemoveHoverColor(DEFAULT_REMOVE_HOVER_COLOR);
                          }}
                        >
                          <Remove color={removeHoverColor} />
                        </div>
                      </div>
                    </>
                  ) : (
                    "Drop CSV file here or click to upload"
                  )}
                </div>
              </>
            )}
          </CSVReader>
        </Form.Group>

        <Alert severity="error" className="mt-2">
          Trouble uploading your sales? Email your file to{" "}
          <a href="mailto:support@sotira.co">support@sotira.co</a> or{" "}
          <a href="https://calendly.com/amritabhasin/15min?back=1&month=2022-08">
            schedule a meeting at this link
          </a>{" "}
          and we will upload it for you :)
        </Alert>
        <div className="d-flex justify-content-between align-items-center csv-dialog-wrapper" id="csv-dialog-wrapper">
          <Typography
            aria-owns={openTooltip ? "mouse-over-popover" : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            className="csv-advanced-button"
            id="csv-advanced-button"
          >
            <Button
              block
              size="sm"
              disabled={advanceDisableButton}
              onClick={() => setOpenModal(true)}
              className={
                advanceDisableButton
                  ? "mt-3 float-left disable-button "
                  : "mt-3 float-left"
              }
            >
              Advanced
            </Button>
          </Typography>
          <Popover
            id="mouse-over-popover"
            open={openTooltip}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            {advanceDisableButton && (
              <Typography className="questionmark-popover text-white p-1">
                Please upload a csv/excel sheet first!!!
              </Typography>
            )}
          </Popover>
          <Button
            block
            size="sm"
            type="submit"
            disabled={importDisableButton}
            className="mt-3 csv-sheet-button"
            id="csv-sheet-button"
          >
          {loading ?
          <><CircularProgress className="file-loader mr-3" /> Uploading </>
          : ' Import CSV Sheet'
          }  
          </Button>
          </div>
      </Form>
    </>
  );
}

export default ReadSaleCsv;